import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/teachers/TeachersAction";
import * as uiHelpers from "../TeachersUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useTeachersUIContext } from "../TeachersUIContext";
export function TeachersTable({
  renewContracts,
  deleteContracts,
  deleteTeachers
}) {
  // Teachers UI Context
  const teachersUIContext = useTeachersUIContext();
  const teachersUIProps = useMemo(() => {
    return {
      ids: teachersUIContext.ids,
      setIds: teachersUIContext.setIds,
      queryParams: teachersUIContext.queryParams,
      setQueryParams: teachersUIContext.setQueryParams,
      openEditTeacherPage: teachersUIContext.openEditTeacherPage
    };
  }, [teachersUIContext]);

  // Getting curret state of Teachers list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.teachers }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isAdditionAuthorized, isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // Teachers Redux state
  const dispatch = useDispatch();

  useEffect(() => {    
    teachersUIProps.setIds([]);
    dispatch(actions.getTeachers(teachersUIProps.queryParams));
    return () => dispatch(actions.cleanTeachersState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teachersUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "photoStr",
      text: "Fotoğraf",
      formatter: columnFormatters.PhotoColumnFormatter,
      style: {
        minWidth: "100px"
      }
    },
    {
      dataField: "tcKimlikNo",
      text: "TC Kimlik No",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret,
    },    
    {
      dataField: "surname",
      text: "Soyadı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "branch",
      text: "Branşı",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      term: teachersUIProps.queryParams.term,
      isAdditionAuthorized,
      isEditionAuthorized,
      isDeletionAuthorized,
      renewContracts,
      deleteContracts,
      openEditTeacherPage: teachersUIProps.openEditTeacherPage,
      deleteTeachers
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-16",
    style: {
      width: "180px",
    }
  }

  if (isEditionAuthorized || isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: teachersUIProps.queryParams.pageSize,
    page: teachersUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                teachersUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: teachersUIProps.ids,
                setIds: teachersUIProps.setIds,
                hidden: !isAdditionAuthorized && !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}